import { render } from "./TransitionExpandX.vue?vue&type=template&id=ad5286f0&scoped=true"
import script from "./TransitionExpandX.vue?vue&type=script&lang=js"
export * from "./TransitionExpandX.vue?vue&type=script&lang=js"

import "./TransitionExpandX.vue?vue&type=style&index=0&id=ad5286f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad5286f0"]])

export default __exports__